import React from "react";
import { MdErrorOutline, MdRefresh } from "react-icons/md";
import styles from "./ErrorScreen.module.scss";
import { EmptyState } from "../../../common/components/emptyState/EmptyState";

interface ErrorScreenProps {
  error?: Error | string;
  onRetry?: () => void;
}

export const ErrorScreen: React.FC<ErrorScreenProps> = ({ error, onRetry }) => {
  const errorMessage =
    typeof error === "string"
      ? error
      : error?.message || "Не удалось загрузить конфигурацию";

  return (
    <div className={styles.container}>
       <div className={styles.wrapper}>
      <EmptyState
        icon={MdErrorOutline}
        title="Ошибка загрузки"
        description={errorMessage}
      />

      {onRetry && (
        <button className={styles.retryButton} onClick={onRetry}>
          <MdRefresh size={20} />
          <span>Повторить</span>
        </button>
      )}
      </div>
    </div>
  );
};